/**
 * Built-in colorway presets that owners can apply to templates.
 * Each preset defines colors for all graph types.
 */

export const DEFAULT_COLORWAY = {
  impressions_graph: "#009efd",
  sales_graph: "#009efd",
  revenue_graph: "#009efd",
  sales_over_time_graph: "#009efd",
  rentals_over_time_graph: "#009efd",
  impressions_over_time_graph: "#009efd",
  impression_revenue_over_time_graph: "#009efd",
  total_earnings_over_time_graph: "#009efd",
  roi_graph: "#28a745",
  roi_over_time_graph: "#28a745",
  primary_color: null,
};

export const COLORWAY_PRESETS = [
  {
    key: "default",
    label: "colorwayPresets.default",
    colors: { ...DEFAULT_COLORWAY },
  },
  {
    key: "ocean",
    label: "colorwayPresets.ocean",
    colors: {
      impressions_graph: "#6CC3E0",
      sales_graph: "#0055CC",
      revenue_graph: "#009efd",
      sales_over_time_graph: "#0055CC",
      rentals_over_time_graph: "#6CC3E0",
      impressions_over_time_graph: "#009efd",
      impression_revenue_over_time_graph: "#5E4DB2",
      total_earnings_over_time_graph: "#0055CC",
      roi_graph: "#4BCE97",
      roi_over_time_graph: "#4BCE97",
      primary_color: null,
    },
  },
  {
    key: "sunset",
    label: "colorwayPresets.sunset",
    colors: {
      impressions_graph: "#FEA362",
      sales_graph: "#Ff0168",
      revenue_graph: "#E2B203",
      sales_over_time_graph: "#Ff0168",
      rentals_over_time_graph: "#FEA362",
      impressions_over_time_graph: "#E2B203",
      impression_revenue_over_time_graph: "#F87168",
      total_earnings_over_time_graph: "#AE2E24",
      roi_graph: "#94C748",
      roi_over_time_graph: "#94C748",
      primary_color: null,
    },
  },
  {
    key: "neon",
    label: "colorwayPresets.neon",
    colors: {
      impressions_graph: "#9F8FEF",
      sales_graph: "#4BCE97",
      revenue_graph: "#6CC3E0",
      sales_over_time_graph: "#4BCE97",
      rentals_over_time_graph: "#E774BB",
      impressions_over_time_graph: "#9F8FEF",
      impression_revenue_over_time_graph: "#6CC3E0",
      total_earnings_over_time_graph: "#4BCE97",
      roi_graph: "#94C748",
      roi_over_time_graph: "#94C748",
      primary_color: null,
    },
  },
  {
    key: "monochrome",
    label: "colorwayPresets.monochrome",
    colors: {
      impressions_graph: "#808080",
      sales_graph: "#404040",
      revenue_graph: "#000000",
      sales_over_time_graph: "#404040",
      rentals_over_time_graph: "#808080",
      impressions_over_time_graph: "#D3D3D3",
      impression_revenue_over_time_graph: "#000000",
      total_earnings_over_time_graph: "#404040",
      roi_graph: "#808080",
      roi_over_time_graph: "#808080",
      primary_color: null,
    },
  },
  {
    key: "holiday",
    label: "colorwayPresets.holiday",
    colors: {
      impressions_graph: "#AE2E24",
      sales_graph: "#216E4E",
      revenue_graph: "#E2B203",
      sales_over_time_graph: "#216E4E",
      rentals_over_time_graph: "#AE2E24",
      impressions_over_time_graph: "#E2B203",
      impression_revenue_over_time_graph: "#AE2E24",
      total_earnings_over_time_graph: "#216E4E",
      roi_graph: "#4BCE97",
      roi_over_time_graph: "#4BCE97",
      primary_color: null,
    },
  },
];

/**
 * Map from colorway config keys to SettingsContext state keys.
 * Used to apply a colorway to localStorage-based settings.
 */
export const COLORWAY_TO_SETTINGS_MAP = {
  impressions_graph: "impressionsGraphColor",
  sales_graph: "salesGraphColor",
  revenue_graph: "revenueGraphColor",
  sales_over_time_graph: "salesOverTimeGraphColor",
  rentals_over_time_graph: "rentalsOverTimeGraphColor",
  impressions_over_time_graph: "impressionsOverTimeGraphColor",
  impression_revenue_over_time_graph: "impressionRevenueOverTimeGraphColor",
  total_earnings_over_time_graph: "totalEarningsOverTimeGraphColor",
  roi_graph: "roiGraphColor",
  roi_over_time_graph: "roiOverTimeGraphColor",
  primary_color: "customPrimaryColor",
};

/** Human-readable labels for each color slot (i18n keys) */
export const COLOR_SLOT_LABELS = {
  impressions_graph: "colorwayPresets.slots.impressionsGraph",
  sales_graph: "colorwayPresets.slots.salesGraph",
  revenue_graph: "colorwayPresets.slots.revenueGraph",
  sales_over_time_graph: "colorwayPresets.slots.salesOverTimeGraph",
  rentals_over_time_graph: "colorwayPresets.slots.rentalsOverTimeGraph",
  impressions_over_time_graph: "colorwayPresets.slots.impressionsOverTimeGraph",
  impression_revenue_over_time_graph:
    "colorwayPresets.slots.impressionRevenueOverTimeGraph",
  total_earnings_over_time_graph:
    "colorwayPresets.slots.totalEarningsOverTimeGraph",
  roi_graph: "colorwayPresets.slots.roiGraph",
  roi_over_time_graph: "colorwayPresets.slots.roiOverTimeGraph",
  primary_color: "colorwayPresets.slots.primaryColor",
};
